var map = {
	"./ci/banner.png": 41997,
	"./mr/banner.png": 85022,
	"./ne/banner.png": 74892,
	"./sn/banner.png": 56784,
	"assets/images/identite/ci/banner.png": 41997,
	"assets/images/identite/mr/banner.png": 85022,
	"assets/images/identite/ne/banner.png": 74892,
	"assets/images/identite/sn/banner.png": 56784
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48542;